<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { Participant, generateBfsLink } from "../helpers/api";
    import ResultRow from "./ResultRow.svelte";
    import { ArrowLeftLine } from "svelte-remixicon";
    import { createEventDispatcher } from "svelte";

    const dispatch = createEventDispatcher();

    export let result: Participant;

    function data(elm) {
        if (elm == undefined) {
            return '';
        }
        if (typeof(elm) == "string") {
            return elm.toString();
        }
        return '';
    }

    function textData(elm, code) {
        if (typeof(elm) == "boolean") {
            if (elm == true) {
                return $_('search.detail.' + code + 'Yes');
            } else {
                return $_('search.detail.' + code + 'No');
            }
        }
    }

    function mobileBack() {
        dispatch('back');
    }
</script>

{#if result != null}
    <div class="flex md:hidden items-center mb-1">
        <span class="mr-1" on:click={mobileBack}>
            <ArrowLeftLine />
        </span>
        <span class="leading-none mt-[2px]">{$_('back')}</span>
    </div>
    <div class="flex items-center text-xl font-bold">
        {data(result.address[0].name)}
    </div>
    <ResultRow text={data(result.address[0].additionalName)} />
    <ResultRow text="{data(result.address[0].street)} {data(result.address[0].houseNumber)}" />
    <ResultRow text={data(result.address[0].additionalAddressInfo)} />
    <ResultRow text="{result.address[0].countryCode}-{data(result.address[0].zip)} {data(result.address[0].city)}" />
    <div class="h-1"></div>
    <ResultRow title={$_('search.detail.majorPhoneNumber')}
               text={data(result.address[0].majorPhoneNumber)}
               link={data(result.address[0].majorPhoneNumberLink)}
               link_type="tel" />
    <ResultRow title={$_('search.detail.email')}
               text={data(result.address[0].email)}
               link={data(result.address[0].email)}
               link_type="mailto" />
    <ResultRow title={$_('search.detail.urlforEInvoicingInfo')}
               text={data(result.address[0].urlforEInvoicingInfo)}
               link={data(result.address[0].urlforEInvoicingInfo)} />
    <ResultRow title={$_('search.detail.additionalDirectContactInfo')}
               text={data(result.address[0].additionalDirectContactInfo)} />
    {#each result.organisation.uidcommercialRegister as id, i}
        <ResultRow title={i === 0 ? $_('search.detail.uidcommercialRegister') : ''}
                   text={data(id) + ' ' + $_('search.detail.uidcommercialRegisterSuffix')}
                   link={generateBfsLink(data(id), $_('code'))} link_style="link-none" />
    {/each}
    {#each result.organisation.uidtax as id, i}
        <ResultRow title={i === 0 ? $_('search.detail.uidtax') : ''}
                   text={data(id) + ' ' + $_('search.detail.uidtaxSuffix')}
                   link={generateBfsLink(data(id), $_('code'))} link_style="link-none" />
    {/each}
    <div class="h-1"></div>
    <ResultRow title={$_('search.detail.networkID')} title_style="title-bold"
               text={data(result.networkParticipantData[0].networkID)} />
    {#if result.networkParticipantData[0].senderInfo !== null}
        <div class="h-2"></div>
        <div class="text-base font-bold">
            {$_('search.detail.senderInfo')}
        </div>
        <ResultRow title={$_('search.detail.senderParticipantID')} copy={true}
                   text={data(result.networkParticipantData[0].senderInfo.senderParticipantID)} />
        <ResultRow title={$_('search.detail.canSendStructuredLineItems')}
                   text={textData(result.networkParticipantData[0].senderInfo.canSendStructuredLineItems,
                   'canSendStructuredLineItems')} />
    {/if}
    {#if result.networkParticipantData[0].receiverInfo !== null}
        <div class="h-2"></div>
        <div class="text-base font-bold">
            {$_('search.detail.receiverInfo')}
        </div>
        <ResultRow title={$_('search.detail.receiverParticipantID')} copy={true}
                   text={data(result.networkParticipantData[0].receiverInfo.receiverParticipantID)} />
        <ResultRow title={$_('search.detail.canReceiveWithoutStructuredLineItems')}
                   text={textData(result.networkParticipantData[0].receiverInfo.canReceiveWithoutStructuredLineItems,
                   'canReceiveWithoutStructuredLineItems')} />
        <ResultRow title={$_('search.detail.canReceiveWithoutSetupProcedure')}
                   text={textData(result.networkParticipantData[0].receiverInfo.canReceiveWithoutSetupProcedure,
                   'canReceiveWithoutSetupProcedure')} />
    {/if}
    <div class="h-2"></div>
    <div class="text-base font-bold">
        {$_('search.detail.additionalInfo')}
    </div>
    <ResultRow title={$_('search.detail.otherEProcessesAvailable')}
               text={textData(result.networkParticipantData[0].additionalInfo.otherEProcessesAvailable,
               'otherEProcessesAvailable')} />
    <ResultRow title={$_('search.detail.isFirstContactDesiredDirectly')}
               text={textData(result.networkParticipantData[0].additionalInfo.isFirstContactDesiredDirectly,
               'isFirstContactDesiredDirectly')} />
{/if}

<style windi:preflights>
</style>
